import React, { Component } from 'react'
import { navigate } from 'gatsby'

// Components
import Layout from '../layout/Layout.jsx'
import Header from '../components/Header'
import Card from '../components/Card.jsx'
import SelectBar from '../components/SelectBar.jsx'
import MpList from '../data/MPList'
import References from '../components/References.jsx'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mps: MpList,
      selectedMps: [],
      isFormVisible: false,
      isOpen: false,
      limit: 3,
      formData: {
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        postcode_number: '',
      },
      isWaitingForResponse: false,
      isFormSubmitted: false,
      triggerLimitNotification: false,
      referenceToggle: false,
      emailValid: true,
    }
  }

  componentDidMount() {
    // let params = this.props.location.search ? this.props.location.search : ''
    // navigate('/results' + params)
    // check if there's any active selections
    this.setState({ selectedMps: this.state.mps.filter(mp => mp.isActive) })

    // this.checkIfCrew()

    // check if voted
    if (localStorage.getItem('voted')) {
      let params = this.props.location.search ? this.props.location.search : ''
      navigate('/results' + params)
    }
  }

  componentDidUpdate() {
    if (this.state.triggerLimitNotification) {
      this.turnOffLimitNotification = setTimeout(() => {
        this.setState({ triggerLimitNotification: false })
      }, 2000)
    }
  }

  componentWillUnmount() {
    clearTimeout(this.turnOffLimitNotification)
  }

  handleActiveState = selectedMp => {
    this.toggleActiveFlag(selectedMp)
    // because it tries to toggle first, selectedMp has to be active.
    if (selectedMp.isActive) {
      // adds from selectedMps state
      this.setState({
        selectedMps: [
          ...this.state.selectedMps,
          ...this.state.mps.filter(mp => mp.name === selectedMp.name),
        ],
      })
    } else {
      // removes to selectedMps state
      this.setState(prevState => ({
        selectedMps: prevState.selectedMps.filter(
          mp => mp.name !== selectedMp.name
        ),
      }))
    }
  }

  toggleActiveFlag = selectedMp => {
    // exits function if limit exceeds
    if (
      !selectedMp.isActive &&
      this.state.selectedMps.length >= this.state.limit
    ) {
      this.setState({ triggerLimitNotification: true })
      return
    }
    const temp = this.state.mps
    temp.forEach(mp => {
      if (mp.name === selectedMp.name) {
        mp.isActive = !mp.isActive
      }
    })
    this.setState({ mps: temp })
  }

  handleTogglePetition = e => {
    this.setState(prevState => ({
      isFormVisible: !prevState.isFormVisible,
    }))
  }

  handleFormInputChange = e => {
    const name = e.target.name
    const value = e.target.value

    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value,
      },
    })
  }

  validateField = (fieldName, value) => {
    let emailValid

    switch (fieldName) {
      case 'email':
        emailValid = value.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
        break
      default:
        break
    }
    return emailValid ? true : false
  }

  handleBlur = e => {
    const name = e.target.name
    const value = e.target.value

    this.setState({ emailValid: this.validateField(name, value) })
  }

  handleFormSubmit = e => {
    e.preventDefault()
    console.log('hello')
    const {
      email,
      first_name,
      last_name,
      postcode_number,
      mobile,
    } = this.state.formData
    const url = 'https://www.getup.org.au/api/take_action_with_external'
    // const module_id = 36078
    // const page_id = 7119
    const module_id = 54848
    const page_id = 22574
    const external_source = 'vto'
    const vote_them_out_votes = this.state.selectedMps
      .map(mp => mp.name)
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '_')

    this.setState({ isWaitingForResponse: true })

    const payload = {
      module_id: module_id,
      page_id: page_id,
      external_source: external_source,
      custom_fields: {
        vote_them_out_votes,
      },
      email,
      first_name,
      last_name,
      postcode_number,
      mobile,
    }

    fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'same-origin',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        console.log(response)
        if (response.status === 200) {
          this.setState({ isWaitingForResponse: false, isFormSubmitted: true })
          localStorage.setItem('voted', true)
          let params = ''
          if (this.props.location.search) {
            params = this.props.location.search
          }
          navigate('/results' + params, { state: { isFormSubmitted: true } })
        } else {
          // todo: handle error
        }
      })
      .catch(console.error.bind(console))
  }

  // getParameterByName(name) {
  //   if (this.props.location.search) {
  //     const url = this.props.location.search
  //     name = name.replace(/[\[\]]/g, '\\$&')
  //     const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
  //       results = regex.exec(url)
  //     if (!results) return null
  //     if (!results[2]) return ''
  //     return decodeURIComponent(results[2].replace(/\+/g, ' '))
  //   }
  // }

  // checkIfCrew = () => {
  //   const value = this.getParameterByName('s')
  //   if (value === 'crew') {
  //     localStorage.setItem('crew', true)
  //   } else if (value === 'md') {
  //     localStorage.setItem('md', true)
  //   }
  // }

  render() {
    return (
      <Layout>
        <Header header={header} />
        <div
          className={
            'row fix-safari-z-index' + (this.state.isFormVisible && ' noscroll')
          }
        >
          {this.state.mps.map(mp => (
            <Card
              key={mp.name.toString()}
              mp={mp}
              onClick={this.handleActiveState}
            />
          ))}
        </div>
        <SelectBar
          mps={this.state.selectedMps}
          onNextClick={this.handleTogglePetition}
          isFormVisible={this.state.isFormVisible}
          removeSelectedMp={this.handleActiveState}
          onFormSubmit={this.handleFormSubmit}
          formData={this.state.formData}
          handleFormInputChange={this.handleFormInputChange}
          isWaitingForResponse={this.state.isWaitingForResponse}
          triggerLimitNotification={this.state.triggerLimitNotification}
          handleBlur={this.handleBlur}
          emailValid={this.state.emailValid}
        />
        <div className="row">
          <div className="small-12  columns">
            <hr className="accordion-top" />
            <p
              style={{
                color: 'white',
                fontSize: '16px',
                opacity: 0.9,
                marginBottom: '32px',
              }}
            >
              Decades of political scandals and media exposés have put trust in
              politics at an all time low. Politicians must be held to the
              highest standard and GetUp believes all politicians in this
              country should welcome an independent public body to investigate
              corruption, restore confidence in our elected representatives and
              bring transparency back to our political system.
            </p>
            <a
              onClick={() =>
                this.setState({ referenceToggle: !this.state.referenceToggle })
              }
              className="btn btn-small btn-grey "
            >
              References
            </a>
            <div
              className={
                this.state.referenceToggle
                  ? ' accordion-body active'
                  : 'accordion-body'
              }
            >
              <References />
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

const header = {
  heading: 'The Dodgies',
  subhead: 'Cast your vote!',
  body: [
      '<b>Our crucial window of opportunity to win a Federal anti-corruption commission is just weeks away.</b>',
      'Not one but <i>four</i> bills introducing a Federal ICAC are due for debate when Parliament sits at the end of this month<sup>1,2,3</sup>  — <b>so let’s shine a light on the scandals Morrison would rather everyone forget.</b>',
      '<b>From Porter’s blind trust<sup>4</sup> to Dutton’s au pairs,<sup>5</sup> the Morrison Government has given us no shortage of doozies to choose from.</b> But there can only be one winner — so vote now and have your pick counted!'
  ],
  subtitleBold:
    'You can choose up to three: vote now on the biggest, dodgiest political scandals of recent years!',
}

export default App
